import { defineComponent as _defineComponent } from 'vue';
import { BPopover } from "bootstrap-vue";
import { computed } from "vue";
import { useStorageLocationConfiguration } from "@/composables/storageLocation";
import ShowSelectedObjectStore from "@/components/ObjectStore/ShowSelectedObjectStore.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PreferredStorePopover',
    props: {
        historyId: null,
        historyPreferredObjectStoreId: null,
        user: null
    },
    setup(__props) {
        const props = __props;
        const { isOnlyPreference } = useStorageLocationConfiguration();
        const preferredObjectStoreId = computed(() => {
            let id = props.historyPreferredObjectStoreId;
            if (!id) {
                id = props.user.preferred_object_store_id;
            }
            return id;
        });
        const title = computed(() => {
            if (isOnlyPreference.value) {
                return "Preferred Storage Location";
            }
            else {
                return "Storage Location";
            }
        });
        return { __sfc: true, isOnlyPreference, props, preferredObjectStoreId, title, BPopover, ShowSelectedObjectStore };
    }
});
